import React from 'react';
import SitePage from './SitePage';

/** Our Story is a site page; the shared renderer does the work. */
export default function OurStory() {
  return <SitePage slug="our-story" />;
}
